var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"text-center"},[_c('h3',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('errors.page_not_found')))]),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(" "+_vm._s(_vm.$t('errors.go_home'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }